// DualView — 1×2 grid (front pair only) or 2×2 grid (all 4 views).
//
// In 4-view mode each view renders its own inline side panel (the panel
// positions itself on the outer edge of the grid via `sidePanelOnLeft` in
// View). L/R views are fully annotatable, with per-side keypoint visibility
// already enforced by `visibleKeypoints(side)` in config/keypoints.ts.

import type * as React from 'react';
import { cn } from '../../lib/cn';
import { useStore } from '../../store';
import { View } from './View';

export interface DualViewProps {
  className?: string;
}

export function DualView({ className }: DualViewProps): React.ReactElement {
  const hasLeftRight = useStore(
    (s) => s.availableSides.includes('left') && s.availableSides.includes('right')
  );

  if (hasLeftRight) {
    return (
      <div className={cn('grid h-full grid-cols-2 grid-rows-[3fr_2fr] gap-2', className)}>
        <View side="front_left" />
        <View side="front_right" />
        <View side="left" />
        <View side="right" />
      </div>
    );
  }

  return (
    <div className={cn('grid h-full grid-cols-2 gap-2', className)}>
      <View side="front_left" />
      <View side="front_right" />
    </div>
  );
}
